export default __webpack_public_path__ + "../ckeditor/plugins/link/images/hidpi/anchor.png";